import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';

export class hojaRespuestas {
  allocation_id?: Number;
  answers?: respuesta[]
}

export class respuesta {
  question_id?: Number;
  answerOption_id?: Number;
  comment?: string;
}
@Injectable({
  providedIn: 'root'
})

export class HojaRespuestasService {
  private apiURL = environment.api_cuestionariosA_rest;
  private headers = new HttpHeaders().append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + localStorage.getItem('token'));
  private apiURLadm = 'https://api-adminclient.rflatina.com/rfl/api/v1/';
  private headersAr = new HttpHeaders().append('enctype', 'multipart/form-data')
  .append('Authorization', 'Bearer ' + localStorage.getItem('token'));

  constructor(
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public postHojaRespuestas(idAsig, resp){
    var res = []
    for(const r of resp){
      res.push({
        question_id: Number(r.idPregunta),
        answerOption_id: Number(r.idRespuesta),
        comment: r.comment || ''
      })
    }
    var hojaRes: hojaRespuestas = {
      allocation_id: Number(idAsig),
      answers: res
    }
    const body = JSON.stringify(hojaRes);
    const apiURL = this.apiURL + 'resolution';
    return this.http.post(`${apiURL}`, body, {headers: this.headers});
  }

  public postFinalize(id){
    const apiURL = this.apiURL + 'resolution/' + id + '/finalize';
    return this.http.post(`${apiURL}`, undefined, {headers: this.headers});
  }
    //OBTENCION DE LOGO INSTITUCION
  public getLogo(idInst): Observable<any>{
    const apiURL = this.apiURLadm+"files?id_company="+idInst+"&folder=expediente ";
    return this.http.get(`${apiURL}`, {headers: this.headersAr});
  }

  public getArchivosA(idFile): Observable<any>{
    const apiURL = this.apiURLadm+"files/"+idFile;
    return this.http.get(`${apiURL}`, {headers: this.headersAr, 'responseType'  : 'arraybuffer' as 'json'});
  }
}
